window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
        window.dataLayer.push({ 'event': 'join_the_waitlist','event_type': 'acquisition '});
    }
    if (e.detail.type == 'open') {
        window.dataLayer.push({ 
          'event': 'overlay_page_view', 
          'virtual_url': 'https://thefeets.com/overlay/waitlist',
          'virtual_title': 'Waitlist Overlay'
        });
    }
});
if ( document.querySelector("#headerjoinwaitlist") ) {
  document.querySelector("#headerjoinwaitlist").addEventListener("click", function(e){
    window.dataLayer.push({ 'event': 'join_the_waitlist_header_click','event_type': 'pre_acquisition '});
  });
}
if ( document.querySelector('a[href^="#waitlist"]:not(#headerjoinwaitlist)') ) {
  document.querySelector('a[href^="#waitlist"]:not(#headerjoinwaitlist)').addEventListener("click", function(e){
    window.dataLayer.push({ 'event': 'join_the_waitlist_click','event_type': 'pre_acquisition '});
  }); 
}
if ( document.querySelector('#ContactForm') ) {
  document.querySelector('#ContactForm').addEventListener("submit", function(e){
    window.dataLayer.push({ 'event': 'get_in_touch','event_type': 'acquisition '});
  }); 
}


